<!-- TODO componente non usato -->
<div class="container-card-related d-flex">
    <div class="container-card-related__left col-6">
        <p class="container-card-related__left__date">30/04/22</p>
        <p class="container-card-related__left__hour">9:30 - 12.30</p>
        <p class="container-card-related__left__title">Nome Location</p>
    </div>
    <div class="container-card-related__right d-flex flex-column justify-content-between col-6">
        <div class="container-card-related__right__top">
            <p class="container-card-related__right__top__metatag">CATEGORIA 1, CATEGORIA 2 +2</p>
            <p class="container-card-related__right__top__title">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>
        <div class="container-card-related__right__bottom d-flex">
            <p>Scopri</p>
        </div>
    </div>
</div>